import { ROUTES } from '@aibees/elephant/router';
import { HeaderContent, RecordType } from '../types';

export function useRecordHeader(value: RecordType): HeaderContent {
  const headerContentMap: Record<RecordType, HeaderContent> = {
    lists: {
      icon: 'list',
      title: 'Lists Manager',
      route: ROUTES.listPage,
    },
    saved: {
      icon: 'bookmark',
      title: 'Saved Manager',
      route: ROUTES.searchListSaved,
    },
    labels: {
      icon: 'label',
      title: 'Labels Manager',
      route: ROUTES.labelPage,
    },
    exports: {
      icon: 'export',
      title: 'Exports Manager',
      route: ROUTES.searchListExport,
    },
  };

  return headerContentMap[value] || headerContentMap.lists;
}
